export default __webpack_public_path__ + "static/boss-ab3d921a483556ac576c4b90f13c9769.png";